import field from './field'

export default {
  // 場域設定
  ...field,
}
